import State from '../core/State';
import initialState from '../initialState';
import produce, { Draft } from 'immer';
import RootDomain from '../entity/RootDomain';

export const startFetchingRootDomains = () =>
  produce((draft: Draft<State>) => {
    draft.rootDomains.fetching = draft.rootDomains.fetching + 1;
  });

export const setRootDomains = (rootDomains: RootDomain[]) =>
  produce((draft: Draft<State>) => {
    draft.rootDomains.data = rootDomains;
  });

export const finishFetchingRootDomains = () =>
  produce((draft: Draft<State>) => {
    draft.rootDomains.fetching = draft.rootDomains.fetching - 1;
  });

export const disposeRootDomains = () =>
  produce((draft: Draft<State>) => {
    draft.rootDomains.data = initialState.rootDomains.data;
    draft.rootDomains.fetching = initialState.rootDomains.fetching;
  });
